//const BASE_URL = 'http://localhost:5000';
//const SMS_URL = 'https://api.novamaxgh.com/api/sms/';

const BASE_URL = 'https://api.novamaxgh.com';
export default BASE_URL;